const DEFAULT_HOTEL_HOME = '/frontend-home/hotels/';
const HOTEL_ACCOMMODATION_HOME = '/travel/home-accommodation/';

export default {
    viewEvents: {
        'frontend-shell:navigate': 'navigate',
        'frontend-shell:navigateHome': 'navigateHome',
    },
    eventHandlers: {
        /**
         * @param {string} route
         * @param {object} options
         * @param {Boolean} options.push
         * @param {Boolean} options.trigger
         */
        navigate(route, options = {}) {
            if (route === 'home' || route === 'hotel_seo_home') {
                this.navigateHome();
            } else if (route === 'hotel_native_search') {
                this.navigateHomeAccommodation(route);
            } else {
                Odigeo.Router.navigate(route, options);
            }
        },
        navigateHome() {
            window.location.href = DEFAULT_HOTEL_HOME.concat('#');
        },
        navigateHomeAccommodation(route) {
            window.location.href = HOTEL_ACCOMMODATION_HOME.concat('#') + route;
        },
    },
};
